import { render, staticRenderFns } from "./SpendReport.vue?vue&type=template&id=1fcb0ea4&scoped=true&"
import script from "./SpendReport.vue?vue&type=script&lang=js&"
export * from "./SpendReport.vue?vue&type=script&lang=js&"
import style0 from "./SpendReport.vue?vue&type=style&index=0&id=1fcb0ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcb0ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
